import { Icon, IconProps } from "./Icon";

export function IconApartment(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M3 7.16A.17.17 0 0 1 3.16 7h8.66a.17.17 0 0 1 .17.17V13h1V7.16A1.17 1.17 0 0 0 11.82 6H3.16A1.17 1.17 0 0 0 2 7.16V13h1ZM24 8l-1-8h-6.8L15 8h4v14h1V8Zm-6.94-7h5l.78 6h-6.68ZM13 14H2a2 2 0 0 0 0 4v4h1v-4h9v4h1v-4a2 2 0 1 0 0-4Zm0 3H2a1 1 0 1 1 0-2h11a1 1 0 1 1 0 2ZM0 23h24v1H0z" />
    </Icon>
  );
}
